import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { Button, CircularProgress, useMediaQuery } from '@mui/material'

import { mainApi } from '../../../../store/services/mainApi'
import StyledBox from '../../StyledBox/StyledBox'
import { DataGrid, GridPagination, GridToolbar, GridToolbarContainer, GridToolbarExport, useGridApiContext } from '@mui/x-data-grid'
import { ReactComponent as Like } from '../../../components/assets/images/Like.svg'
import { ReactComponent as InProgress } from '../../../components/assets/images/inProgress.svg'
import { ReactComponent as Production } from '../../../components/assets/images/cap.svg'
import { ReactComponent as Delivery } from '../../../components/assets/images/scooterDelivery.svg'
import { ReactComponent as CONGEDOR } from '../../../components/assets/images/CongeladorFP.svg'
import { Box } from '@mui/material'
import swipeLeft from '../../../components/assets/images/swipe-left-icon.svg'

import { digitalAppApi } from '../../../../store/services/digitalAppApi'
import usePdfBlobUrl from '../../../../hooks/usePdfBlobUrl'
import { buildAlbaranPrintParams } from '../../../../utils/buildFacturaPrintParams'
import FastOrder from '../../StaticPage/FastOrder/FastOrder'
import FastTempleOrder from '../../../components/FastTempleOrder/FastTempleOrder'
import { useSelector } from 'react-redux'
import IvaPriceSwitch from '../../../../components/IvaPriceSwitch/IvaPriceSwitch'
import {
  formatMoney,
  getItemIvaRate,
  getLinePrice,
  getLineTotal,
  grossToNet,
  truncateToDecimals,
} from '../../../../utils/orderLineCalculations'

export const StaticOrderFP = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const ivaSwitch = useSelector((state) => state.contextUI.PriceIVA)

  const [orderId, setOrderId] = useState(location.pathname.split('/').pop())

  const mobile = useMediaQuery('(max-width: 768px)')
  const {
    data: order,
    isLoading,
    isError,
  } = mainApi.useGetOrdersByIdQuery(orderId, {
    pollingInterval: 50000,
  })

  const [deliveryDate, setDeliveryDate] = useState('')
  const [creationDate, setCreationDate] = useState('')
  const [creationTime, setCreationTime] = useState('')
  const [items, setItems] = useState([])
  const [rows, setRows] = useState([])

  useEffect(() => {
    if (order) {
      document.title = `Order ${order._id.slice(-6)} ${order?.tradeName || order.userAcc?.tradeName || 'No TradeName'}`
      // Устанавливаем deliveryDate после получения order
      setDeliveryDate(order.deliveryDate ? order.deliveryDate : '')

      // Устанавливаем items после получения order
      setItems(order.items)

      // Устанавливаем дату и время создания после получения order
      const date = new Date(order.date)
      const localeDate = date.toLocaleDateString() // Получаем локализованную дату
      const localeTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) // Получаем локализованное время

      setCreationDate(localeDate)
      setCreationTime(localeTime)

      // Устанавливаем rows после получения order
      setRows(order.items)
    }
  }, [order])

  const statusBackground = (status) => {
    switch (status) {
      case 'Ready':
        return <Like width={20} height={20} />
      case 'PROCESSING':
        return <InProgress width={20} height={20} />
      case 'NOT AVAILABLE':
        return '⛔'
      case 'CHECKING':
        return '👁️'
      case 'PRODUCTION':
        return <Production width={20} height={20} /> //Production
      case 'SHOPPING':
        return <Delivery fill='#6D26E1' width={20} height={20} />
      case 'CONGEDOR':
        return <CONGEDOR width={20} height={20} />
      case 'DEVOLUCION':
        return '🔙'
      case 'CONFIRMAR':
        return '👍'
      default:
        return null
    }
  }

  const [openDialog, setOpenDialog] = useState(false)
  const [statusName, setStatusName] = useState('')

  const handleCellClick = (params, event) => {
    if (params.field === 'status') {
      setStatusName(params.row.status.name) // предполагается, что статус находится в params.row.status
      setOpenDialog(true)
    }
  }

  const CustomFooter = () => {
    const apiRef = useGridApiContext()

    return (
      <GridToolbarContainer sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {/* <GridToolbarExport /> */}
        {/* Здесь можно добавить любой кастомный контент */}
        <Box>
          <img src={swipeLeft} alt='swipe' width={30} height={30} />
        </Box>
        <Box>
          <GridPagination />
        </Box>
        {/* Кнопки переключения страниц будут добавлены автоматически */}
      </GridToolbarContainer>
    )
  }

  const columns = [
    {
      field: 'img',
      headerName: 'Image',
      width: 70,
      sortable: false, // Отключает сортировку для колонки
      filterable: false, // Отключает фильтрацию для колонки
      disableColumnMenu: true, // Отключает меню столбцов
      renderHeader: () => {
        return <p style={{ margin: '0 auto' }}>Image</p>
      },
      renderCell: (params) => {
        return <img src={params.value} alt='' style={{ width: '50px', height: '50px' }} />
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 70,
      sortable: false,
      filterable: false, // Отключает фильтрацию для колонки
      disableColumnMenu: true, // Отключает меню столбцов
      renderCell: (params) => (
        <p title={params.value.name} style={{ margin: '0 auto' }}>
          {statusBackground(params.value.name)}
        </p>
      ),
    },

    {
      field: 'currentUnit',
      headerName: 'Unit',
      filterable: false, // Отключает фильтрацию для колонки
      disableColumnMenu: true, // Отключает меню столбцов
      width: 70,
      renderCell: (params) => <p>{params.value}</p>,
    },
    {
      field: 'quantity',
      filterable: false, // Отключает фильтрацию для колонки
      disableColumnMenu: true, // Отключает меню столбцов
      headerName: 'Quantity',
      width: 80,
      renderCell: (params) => <p>{params.value}</p>,
    },

    {
      field: 'marketPriceCP',
      filterable: false, // Отключает фильтрацию для колонки
      disableColumnMenu: true, // Отключает меню столбцов
      headerName: 'Price',
      width: 70,
      renderCell: (params) => <p>{formatMoney(getLinePrice(params.row, ivaSwitch))}</p>,
    },
    {
      field: 'IVA',
      headerName: 'IVA',
      filterable: false, // Отключает фильтрацию для колонки
      disableColumnMenu: true, // Отключает меню столбцов
      width: 50,
      renderCell: (params) => <p>{getItemIvaRate(params.row)}%</p>,
    },

    {
      field: 'total',
      headerName: 'Total',
      filterable: false, // Отключает фильтрацию для колонки
      disableColumnMenu: true, // Отключает меню столбцов
      width: 80,
      renderCell: (params) => <p>{formatMoney(getLineTotal(params.row, ivaSwitch))}</p>,
    },
    {
      field: 'name',
      headerName: 'Name',
      filterable: false, // Отключает фильтрацию для колонки
      disableColumnMenu: true, // Отключает меню столбцов
      width: 300,
      renderCell: (params) => (
        <p
          style={{
            maxWidth: '300px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            // marginBottom: 0, // Убираем отступ снизу, если он есть
          }}
        >
          {params.value}
        </p>
      ),
    },
  ]

  const totals = useMemo(() => {
    if (!order?.items) {
      return { total: 0, base: 0, iva: 0, paid: 0, balance: 0, deliveryDisplay: 0 }
    }

    const itemsGross = truncateToDecimals(order.items.reduce((sum, item) => sum + getLineTotal(item, true), 0), 2)
    const itemsBase = truncateToDecimals(order.items.reduce((sum, item) => sum + getLineTotal(item, false), 0), 2)

    const deliveryGross = truncateToDecimals(order?.deliveryPrice || 0, 2)
    const deliveryBase = truncateToDecimals(grossToNet(deliveryGross, 10), 2)
    const deliveryDisplay = ivaSwitch ? deliveryGross : deliveryBase
    const paid = truncateToDecimals(order?.paidValue || 0, 2)

    const total = truncateToDecimals((ivaSwitch ? itemsGross : itemsBase) + deliveryDisplay, 2)
    const base = truncateToDecimals(itemsBase + deliveryBase, 2)
    const iva = truncateToDecimals((itemsGross + deliveryGross) - (itemsBase + deliveryBase), 2)
    const balance = truncateToDecimals(total - paid, 2)

    return { total, base, iva, paid, balance, deliveryDisplay }
  }, [order, ivaSwitch])

  const albaranQueryArgs = useMemo(
    () =>
      buildAlbaranPrintParams(
        order?._id,
        order?.tradeName || order?.userAcc?.tradeName,
        ivaSwitch,
      ),
    [order?._id, order?.tradeName, order?.userAcc?.tradeName, ivaSwitch],
  )

  const {
    data: albaranBlob,
    isLoading: albaranPdfLoading,
    isError: albaranPdfError,
    isSuccess: albaranPdfSuccess,
  } = digitalAppApi.useGetAlbaranByIdQuery(albaranQueryArgs, {
    skip: !albaranQueryArgs?.id,
  })

  const albaranPdfUrl = usePdfBlobUrl(albaranBlob, albaranPdfSuccess)

  const urlParams = new URLSearchParams(window.location.search);
  const albrandDownload = urlParams.get('albranddownload');
  const albaranRef = useRef()
  useEffect(() => {
    if (albrandDownload && albaranRef.current && albaranPdfUrl) {
      albaranRef.current.click()
    }
  }, [albrandDownload, albaranPdfUrl])

  return isLoading ? (
    <CircularProgress />
  ) : (
    <div
      style={{ width: '95%', margin: '20px auto', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: mobile ? 'column' : 'row',
          gap: '20px',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <StyledBox defaultVisible={false} sx={{ width: 'max-content', minWidth: '300px', maxWidth: '100%' }} headerText={'Order details'}>
          <div className='orderInfo__box__item'>
            <p>
              ORDER: <span>{order?.idTucomida ? order.idTucomida : order?._id ? order?._id.slice(-6) : ''}</span>
            </p>
          </div>

          <div className='orderInfo__box__item'>
            <p>
              PAYMENT TYPE:{' '}
              <span>
                {order?.paymentType !== '-'
                  ? parseFloat(order?.paymentType)
                    ? 'Сдача с ' + order?.paymentType + '€'
                    : order?.paymentType
                  : 'Без сдачи'}
              </span>
            </p>
          </div> 
          <div className='orderInfo__box__item'>
            <p>
              Debt: <span style={{ color: totals.balance <= 0 ? 'green' : 'red', textAlign: 'right' }}>{formatMoney(totals.balance)}</span>
            </p>
          </div>
          <div className='orderInfo__box__item'>
            <p>
              TVA: <span>{formatMoney(totals.iva)}</span>
            </p>
          </div>
          <div className='orderInfo__box__item'>
            <p>
              Delivery: <span>{formatMoney(totals.deliveryDisplay)}</span>
            </p>
          </div>
          <div className='orderInfo__box__item'>
            <p>
              Paid: <span>{formatMoney(totals.paid)}</span>
            </p>
          </div>
          <div className='orderInfo__box__item'>
            <p>
              CREATION:{' '}
              <span>
                {creationDate} {creationTime}
              </span>
            </p>
          </div>
          <div className='orderInfo__box__item'>
            <p>
              DELIVERY: <span>{deliveryDate ? deliveryDate : ''}</span>
              <span>{deliveryDate && deliveryDate.includes(',') ? (deliveryDate.split(',')[1].slice(0, -6) > 12 ? '🌛' : '🌞') : ''}</span>
            </p>
          </div>
          <div className='orderInfo__box__item'>
            <p>
              TOTAL ITEMS: <span>{items ? items?.length : 0}</span>
            </p>
          </div>
          <div className='orderInfo__box__item'>
            <p>
              COMMENT:<span>{order?.description ? order?.description : 'No comment'}</span>
            </p>
          </div>
        </StyledBox>
        <StyledBox defaultVisible={false} sx={{ width: 'max-content', minWidth: '300px', maxWidth: '100%' }} headerText={'Payment details'}>
          <div className='orderInfo__box__item'>
            <p>
              GOODS W/O TVA: <span>{formatMoney(totals.base)}</span>
            </p>
          </div>
          <div className='orderInfo__box__item'>
            <p>
              TVA: <span>{formatMoney(totals.iva)}</span>
            </p>
          </div>
          <div className='orderInfo__box__item'>
            <p>
              Delivery: <span>{formatMoney(totals.deliveryDisplay)}</span>
            </p>
          </div>

          <div className='orderInfo__box__item'>
            <p>
              Total: <span>{formatMoney(totals.total)}</span>
            </p>
          </div>
          
          <div className='orderInfo__box__item' style={{marginTop: '30px'}}>
            <p>
              Balance: <span style={{ color: totals.balance <= 0 ? 'green' : 'red', textAlign: 'right' }}>{formatMoney(totals.balance)}</span>
            </p>
          </div>
          <div className='orderInfo__box__item' style={{marginBottom: '30px'}}>
            <p>
              Paid: <span>{formatMoney(totals.paid)}</span>
            </p>
          </div>
          <div className='orderInfo__box__item'>
            <p>
              Phone: <span>{order?.userAcc?.phone}</span>
            </p>
          </div>
          <div className='orderInfo__box__item'>
            <p>
              Name: <span>{order?.userAcc?.name}</span>
            </p>
          </div>
        </StyledBox>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          margin: '10px 0',
        }}
      >
        <p>STATUS: </p>
        <p
          style={{
            textTransform: 'capitalize',
            padding: '5px',
            borderRadius: '5px',
            backgroundColor: order?.status?.color ? order?.status?.color : '#fff',
            border: '1px solid ' + (order?.status?.color ? order?.status?.color : '#fff'),
            margin: '0 5px',
          }}
        >
          {order?.status.name ? order?.status.name : 'In progress'}
        </p>
        <div
          style={{
            display: 'flex',
            gap: '10px',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          {/* <FastOrder contactID={location.pathname.split('/').pop()} tradeNames={order?.items.map((el) => el.sku) || []} 
            sxBtn={{ width: '100%', padding: '5px 10px', color: '#fff', borderRadius: '10px', cursor: 'pointer', backgroundColor: '#5FC56D', fontFamily: 'Montserrat', fontWeight: 'bold', fontSize: '16px', textWrap: 'nowrap' }}
          /> */}
          <FastTempleOrder 
            tradeNameProp={order?.tradeName}
            filterOrder={location.pathname.split('/').pop()}
            sxBtn={{ width: '100%', height: '38px', padding: '5px 10px', color: '#fff', borderRadius: '10px', cursor: 'pointer', backgroundColor: '#5FC56D', fontFamily: 'Montserrat', fontWeight: 'bold', fontSize: '16px', textWrap: 'nowrap', outline: 'none', border: 'none'}}
            textBtn={'REPETIR'}
          />
          <Button
            size='small'
            variant='contained'
            sx={{ width: '100%', padding: '5px 10px', color: '#fff', borderRadius: '10px', cursor: 'pointer', backgroundColor: '#5FC56D', fontFamily: 'Montserrat', fontWeight: 'bold', fontSize: '16px' }}
            onClick={() => {
              window.open(`order/${order?._id}`, '_blank')
            }}
          >
            COMPARTIR
          </Button>
        </div>
        <IvaPriceSwitch compact />
        {albaranPdfLoading ? (
          <CircularProgress size={20} color='success' />
        ) : albaranPdfError ? (
          <span style={{ color: 'red' }}>Error al generar albarán</span>
        ) : (
          <a
            href={albaranPdfUrl || undefined}
            download={`Albaran ${order?.idTucomida ? order?.idTucomida : order?._id ? order?._id.slice(-6) : 'N/A'}.pdf`}
            target='_blank'
            rel='noreferrer'
            ref={albaranRef}
            style={{ pointerEvents: albaranPdfUrl ? 'auto' : 'none', opacity: albaranPdfUrl ? 1 : 0.5 }}
          >
            Descargar Albarán 🖨️
          </a>
        )}
      </div>
      <div style={{ width: '100%' }}>
        <DataGrid
          autoHeight={true}
          sx={{
            marginTop: '10px',
            backgroundColor: '#fff',
          }}
          onCellClick={handleCellClick}
          getRowId={(row) => row.sku}
          // slots={{ toolbar: GridToolbar }}
          // disableColumnFilter
          // slotProps={{
          //   toolbar: {
          //     showQuickFilter: true,
          //   },
          // }}
          rows={rows}
          columns={columns}
          components={{
            Footer: CustomFooter,
          }}
        />
      </div>
    </div>
  )
}
